import "./Tags.scss";

const Tags = ({tag, className}) => {
  return (
    <span className={`tags ${className ? className : ""}`} >
      &lt;{tag}&gt;
    </span>
  )
}

export default Tags;